import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { Home } from './comp/Home';
import { Mypage } from './comp/Mypage';
import { List0 } from './comp/List0';
import { List1 } from './comp/List1';
import { List2 } from './comp/List2';
import { Form } from './comp/form';
import { Login } from './comp/login';


const App = () => {
  // sessionStorageからIDを取得し、stateに格納
  const [id, setId] = useState(sessionStorage.getItem('ID'));

  // sessionStorageが変更された時にIDを更新
  useEffect(() => {
    const handleStorageChange = () => {
      setId(sessionStorage.getItem('ID'));
    };

    // storageイベントリスナーを追加
    window.addEventListener('storage', handleStorageChange);

    // クリーンアップ関数でリスナーを削除
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);  // 初回レンダリング時にのみ実行

  const title = {
    float: 'left',
  };
  const linkStyle = {
    textDecoration: 'none',
    color: 'BLACK',
    padding: '0 1em',
    fontSize: '1.5em',
    borderRight: 'solid 1px #333',
    lineHeight:'0.9em',
  };
  const contain = {
    margin: '1em',
    padding: '1em',
  };
  const login = {
    float: 'right',
    margin: '0',
  };
  const logout = {
    float: 'right',
    margin: '0',
  };
  const data = {
    fontSize:'0.6em',
    display:'block',
    lineHeight:'0.8em',
  }
  const disable = {
    pointerEvents: 'none',
    cursor: 'not-allowed', // カーソルを「禁止マーク」に
    color: 'gray', /* 見た目で無効状態とわかるように色を変える */
  }

  const handleLogout = () => {
    sessionStorage.clear();
    setId(''); // ログアウト後にIDを空にする
  };

  const currentYear = new Date().getFullYear();

  return (
    <Router>
      <header>
        <Link to="/" style={linkStyle}>TOP</Link>
        <Link to="/mypage" style={linkStyle}>マイページ</Link>
        <Link to="/list0" style={linkStyle}>{currentYear}<span style={data}>年データ</span></Link>
        <Link to="/list1" style={linkStyle}>{currentYear-1}<span style={data}>年データ</span></Link>
        <Link to="/list2" style={linkStyle}>{currentYear-2}<span style={data}>年データ</span></Link>
        <a href="/form?unique=NEW"><button className='new-button'>新規作成</button></a>
        <p style={login}>ログインユーザ：{id}</p>
        <button style={logout} type="submit" onClick={handleLogout}>Logout</button>
      </header>
      <div style={contain}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Home />} />
          <Route path="/mypage" element={<Mypage />} />
          <Route path="/list0" element={<List0 />} />
          <Route path="/list1" element={<List1 />} />
          <Route path="/list2" element={<List2 />} />
          <Route path="/form" element={<Form />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;



